import { Pathname } from 'history';
import { PageTabsNames } from '../constants/PageTabsNames';

const MyVideosPathname = `/${PageTabsNames.MyVideos}`;

export const getActiveTabFromPathname = (pathname: Pathname): PageTabsNames =>
  pathname === MyVideosPathname
    ? PageTabsNames.MyVideos
    : PageTabsNames.Templates;

export const generatePathnameForActiveTab = (tabName: PageTabsNames): string =>
  tabName === PageTabsNames.MyVideos ? MyVideosPathname : '/';
